var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "main-board"
  }, [!_vm.items.length ? _c('li', {
    staticClass: "py-10"
  }, [_c('p', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_vm._v(" 공지사항이 없습니다. ")])]) : _vm._e(), _vm._l(_vm.items, function (_ref) {
    var _id = _ref._id,
      subject = _ref.subject,
      createdAt = _ref.createdAt;
    return _c('li', {
      key: _id
    }, [_c('router-link', {
      staticClass: "w-100",
      attrs: {
        "to": "/community/notice/".concat(_id)
      }
    }, [_c('p', {
      staticClass: "main-board__category font-weight-bold mb-2 mb-md-0"
    }, [_vm._v("KEA")]), _c('p', {
      staticClass: "main-board__tit text-left ellip mb-6 mb-md-0"
    }, [_vm._v(_vm._s(subject))]), _c('p', {
      staticClass: "main-board__date"
    }, [_vm._v(_vm._s(createdAt.toDate()))])])], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }